import { showError, showSuccess, isRequired } from "./";
import messages from "./../messages";

const lang = document.documentElement.lang.startsWith("fr") ? "fr" : "en";

const isPhoneValid = (phone) => {
  const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return pattern.test(phone);
};

const checkPhone = (phone) => {
  let valid = false;
  const phoneNumber = phone.value.trim();
  if (!isRequired(phoneNumber)) {
    showError(phone, messages[lang].required);
  } else if (!isPhoneValid(phoneNumber)) {
    showError(phone, messages[lang].phone_invalid);
  } else {
    showSuccess(phone);
    valid = true;
  }
  return valid;
};
export default checkPhone;
